import { createAction } from '@reduxjs/toolkit';

const toggleRegisterForm = createAction('registerForm/toggleRegisterForm');
export default toggleRegisterForm;
